/**
 * Helper method used to process screenshots captured by the {@code ScreenshotCaptureEffect}.
 *
 * @param {Blob} imageBlob - The blob of the screenshot that has to be processed.
 * @param {Object} options - Custom options required for processing.
 * @returns {Promise<void>}
 */
export async function processScreenshot(imageBlob, options) { // eslint-disable-line no-unused-vars
    return await Promise.resolve();
}
